<template>
    <div class="tooltip-wrapper" @mouseover="isHover = true" @mouseout="hide">
        <slot></slot>
        <span class="tooltip" :class="calculatePosition" v-show="showTooltip && text" ref="tooltipContent">
            <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="tooltip-arrow">
                <path d="M6.58579 1.41421C7.36684 0.633164 8.63316 0.633165 9.41421 1.41421L16 8H0L6.58579 1.41421Z" fill="#2B2D33"/>
            </svg>
            <img :src="icon" alt="text" v-if="icon" class="tooltip-icon" loading="lazy" width="30" height="30">
            <a :href="link" v-if="link" target="_blank">{{text}}</a>
            <span v-else>{{text}}</span>
        </span>
    </div>
</template>

<script>
export default {
    name: "Tooltip",
    props: ['text', 'link', 'icon', 'position'],
    data(){
        return {
            isHover: false,
            showTooltip: false,
            calculatePosition: this.position
        }
    },
    watch: {
        isHover(newVal, oldVal){
            if(newVal){
                setTimeout(() => {
                    this.showTooltip = this.isHover;
                    this.$nextTick(() => {
                        const tooltipInfo = this.$refs.tooltipContent.getBoundingClientRect();
                       if(tooltipInfo.x + tooltipInfo.width > window.outerWidth || tooltipInfo.x < 0){
                            this.calculatePosition =
                                tooltipInfo.x + tooltipInfo.width / 2 > window.outerWidth / 2 ?
                                    'right' : 'left';
                        }
                    })
                }, 500)
            }
        }
    },
    methods: {
        hide(){
            this.showTooltip = false
            this.isHover = false
        }
    }
}
</script>

<style lang="scss">
@import "../../../sass/front/helpers";
.tooltip {
    background: #2B2D33;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 300;
    padding: 10px 15px;
    color: #fff;
    position: absolute;
    top: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 101;
    display: flex;
    align-items: center;
    max-width: calc(100vw - 40px);
    width: max-content;
    text-align: center;
    word-break: break-word;

    @include responsive-below($md){
        max-width: calc(70vw - 20px);
    }

    &-arrow {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
    }

    &-icon {
        max-width: 30px;
        margin-right: 6px;
    }

    &.left {
        left: 0;
        transform: none;
        text-align: left;

        .tooltip-arrow {
            left: 15px;
            transform: none;
        }
    }

    &.right {
        right: 0;
        left: auto;
        transform: none;

        .tooltip-arrow {
            right: 15px;
            left: auto;
            transform: none;
        }
    }
}

.tooltip-wrapper {
    position: relative;
    display: inline-block;
}
</style>
